/** Host to show for a Site address; the address itself when it cannot be parsed, so rendering never throws.
 * Хост для показу адреси сайту; сама адреса, якщо її не розібрати, тож рендер ніколи не падає. */
export function siteHost(url: string): string {
  try {
    return new URL(url).host;
  } catch {
    return url;
  }
}
